import React from "react"
import { Typography, DialogContent } from "@mui/material"
import CompletedQuestionnaire from "./CompletedQuestionnaires"
import PendingQuestionnaire from "./PendingQuestionnaires"
import Notifications from "../../AlertMessage/Notifications"
import Loader from "../../../utils/Loader"
import Title from "../Dialogs/Title"

export default function ManageQuestionnaires(props: any) {
	const { matches } = props
	const questionnaireData = props.data
	const config = {
		headers: {
			Authorization: `Bearer ${
				props.userConfig ? props.userConfig.token : null
			}`,
		},
		partnerApiKey: props.userConfig ? props.userConfig.partnerApiKey : null,
		businessAlias: props.userConfig ? props.userConfig.businessAlias : null,
		id: props.userConfig ? props.userConfig.clientId : null,
	}
	React.useEffect(() => {
		props.getQuestionnaires(config)
	}, [])

	React.useEffect(() => {
		if (
			props.messages === "Successfully submitted Questionnaire" ||
			props.messages === "Successfully updated Questionnaire"
		) {
			props.getQuestionnaires(config)
		}
	}, [props.messages])

	const renderQuestionnaires = () => {
		const sortedAssignments = props.data?.assignments.sort(
			(a: any, b: any) => b.id - a.id
		)

		const questionnaires = sortedAssignments?.map((assignment: any) => {
			const questions = props.data?.questionnaires.find(
				(qs: any) => qs.id === assignment.questionnaireId
			)

			if (!questions) return null

			const isCompleted = assignment?.answers?.length > 0

			return (
				<React.Fragment key={assignment.questionnaireId}>
					{isCompleted ? (
						<CompletedQuestionnaire
							questions={questions.questions}
							name={questions.name}
							matches={matches}
							assignments={assignment}
							onUpdate={props.updateQuestionnaires}
							userConfig={props.userConfig}
							status={props.data.status}
							signature={assignment.signature}
							getSignatureImage={props.getSignatureImage}
							signatureImage={props.signatureImage}
							onClose={props.onClose}
							completed="Completed"
						/>
					) : (
						<PendingQuestionnaire
							questions={questions.questions}
							matches={matches}
							name={questions.name}
							assignments={assignment}
							questionnaireId={questions.id}
							updateQuestionnaires={props.updateQuestionnaires}
							onClose={props.onClose}
							userConfig={props.userConfig}
						/>
					)}
					<Typography align="center" variant="subtitle2">
						{isCompleted ? "Completed" : "Pending"}
					</Typography>
				</React.Fragment>
			)
		})

		return questionnaires
	}

	return (
		<>
			<Title title="Questionnaires" onClose={props.onClose} />
			{props.data ? (
				<>
					<DialogContent sx={{ p: 0, pb: 2, mt: 2 }}>
						{questionnaireData.questionnaires.length === 0 ||
						!questionnaireData.questionnaires ? (
							<Typography align="center" sx={{ p: 2 }}>
								There are no questionnaires
							</Typography>
						) : (
							<>
								{renderQuestionnaires()}

								{props.errors || props.messages ? (
									<Notifications
										messages={props.messages}
										errors={props.errors}
									/>
								) : null}
							</>
						)}
					</DialogContent>
				</>
			) : (
				<Loader />
			)}
		</>
	)
}
